import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule, MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import {
  EnvironmentConfigurationService,
  ENVIRONMENT_CONFIGURATION_VARIABLE,
  RELEASE_VERSION_CONFIGURATION_VARIABLE,
} from '@nimbus-library/features/configuration';
import { SharedModule } from '@nimbus-admin/features/shared/shared.module';
import { AdminUiModule } from '@nimbus-admin/features/shared/admin-ui.module';
import { DECLARED_PIPES, EXPORT_PIPES } from '@nimbus-admin/common/pipes';

export const DECLARED_COMPONENTS = [];
export const EXPORT_COMPONENTS = [];
export const ENTRY_COMPONENTS = [];

@NgModule({
  declarations: [...DECLARED_COMPONENTS, ...DECLARED_PIPES],
  imports: [AdminUiModule, CommonModule, ReactiveFormsModule, SharedModule, MatDialogModule],
  providers: [
    EnvironmentConfigurationService,
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: { closeOnNavigation: true, hasBackdrop: true, backdropClass: 'nimbus-modal-backdrop' },
    },
    { provide: ENVIRONMENT_CONFIGURATION_VARIABLE, useValue: 'EnvironmentConfiguration' },
    { provide: RELEASE_VERSION_CONFIGURATION_VARIABLE, useValue: 'ReleaseVersion' },
  ],
  exports: [...EXPORT_COMPONENTS, ...EXPORT_PIPES],
})
export class NimbusAdminCommonModule {}
